module.exports = __webpack_public_path__ + "static/logo-553e9b8db369303415faefcb03244202.png";